import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function PageShell({ children, className = '', mainClassName = 'flex-grow' }) {
  return (
    <div className={`min-h-screen flex flex-col bg-dc-bg text-dc-text font-lexend ${className}`}>
      <Navbar />
      <main className={mainClassName}>{children}</main>
      <Footer />
    </div>
  );
}